var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/File/Download/"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Union"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99988 2.5C9.72374 2.5 9.49988 2.72386 9.49988 3L9.49988 12.6246C9.48957 12.6153 9.47946 12.6057 9.46955 12.5958L5.35343 8.47972C5.15817 8.28446 4.84159 8.28446 4.64632 8.47972C4.45106 8.67499 4.45106 8.99157 4.64632 9.18683L8.76244 13.3029C9.44586 13.9864 10.5539 13.9864 11.2373 13.3029L15.3534 9.18683C15.5487 8.99157 15.5487 8.67499 15.3534 8.47972C15.1582 8.28446 14.8416 8.28446 14.6463 8.47972L10.5302 12.5958C10.5203 12.6057 10.5102 12.6153 10.4999 12.6246L10.4999 3C10.4999 2.72386 10.276 2.5 9.99988 2.5Z",
    fill: "#5B5C5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.16663 12.5C2.44277 12.5 2.66663 12.7239 2.66663 13V15C2.66663 15.8284 3.3382 16.5 4.16663 16.5H15.8333C16.6617 16.5 17.3333 15.8284 17.3333 15V13C17.3333 12.7239 17.5571 12.5 17.8333 12.5C18.1094 12.5 18.3333 12.7239 18.3333 13V15C18.3333 16.3807 17.214 17.5 15.8333 17.5H4.16663C2.78592 17.5 1.66663 16.3807 1.66663 15V13C1.66663 12.7239 1.89048 12.5 2.16663 12.5Z",
    fill: "#5B5C5B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/Download.7dd1fda2c8a56c624e920d39e32f87f0.svg";
export { ForwardRef as ReactComponent };